import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'

export const TIME_RANGES = ['15m', '1h', '6h', '24h', '7d', '30d', 'custom'] as const
export type TimeRange = (typeof TIME_RANGES)[number]

const LABEL: Record<TimeRange, string> = {
  '15m': '15m',
  '1h': '1h',
  '6h': '6h',
  '24h': '24h',
  '7d': '7d',
  '30d': '30d',
  custom: 'custom…',
}

/**
 * One shared time-range picker per page (data-truth rule #3). Callers persist
 * `value` to the URL so every view stays a shareable permalink.
 */
export function TimeRangePicker({
  value,
  onChange,
}: {
  value: TimeRange
  onChange: (range: TimeRange) => void
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="cursor-pointer rounded-[7px] border border-border bg-canvas px-2.5 py-1.5 text-[12.5px] text-ink hover:border-accent">
          Last {LABEL[value]} ▾
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {TIME_RANGES.map((range) => (
          <DropdownMenuItem
            key={range}
            data-state={range === value ? 'checked' : undefined}
            onSelect={() => onChange(range)}
          >
            {LABEL[range]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
